import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { GoogleMap } from '@agm/core/services/google-maps-types';
import { NgForOf, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Account } from '@core/auth/account.model';
import { AccountService } from '@core/auth/account.service';
import { LoginService } from '@core/login/login.service';
import { FormatMediumDatePipe } from '@date/format-medium-date.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ProgramEnum } from '@model/enumerations/program-enum.model';
import { ICandidatureFrontendGeracaoz } from '@model/geracaoz/candidature-frontend.model';
import { ITask } from '@model/geracaoz/task.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedDataService } from '@services/shared-data-service';
import { GeracaozCandidatureFrontendTaskComponent } from 'app/frontend/geracaoz/geracaoz-candidature-frontend-task.component';
import Geocoder = google.maps.Geocoder;

@Component({
  selector: 'jhi-geracaoz-candidature-frontend',
  templateUrl: './geracaoz-candidature-frontend.component.html',
  imports: [FontAwesomeModule, AgmCoreModule, FormatMediumDatePipe, NgForOf, NgIf],
  standalone: true,
})
export class GeracaozCandidatureFrontendComponent implements OnInit {
  programEnum?: ProgramEnum;
  programEnumLower?: string;
  mainImage?: string;
  account?: Account | null;
  mainBanner?: string;
  enum = ProgramEnum;
  mapLat = 39.69482724691313;
  mapLng = -8.130299785093573;
  zoom = 7;
  markers: { lat: number; lng: number; title: string }[] = [];
  map?: GoogleMap;
  geocoder?: Geocoder;
  nameFilter?: string;
  locationFilter?: string;
  candidature?: ICandidatureFrontendGeracaoz;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    protected modalService: NgbModal,
    private sharedDataService: SharedDataService,
    protected mapsApiLoader: MapsAPILoader,
    private accountService: AccountService,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(({ candidature, programEnum }) => {
      this.programEnum = programEnum;
      this.candidature = candidature;
      this.programEnumLower = (this.programEnum + '').toLowerCase();
      this.mainImage = '/content/images/' + this.programEnumLower + '/logotipo.png?cache=' + new Date().getMilliseconds();
      this.mainBanner = '/content/images/' + this.programEnumLower + '/front.png?cache=' + new Date().getMilliseconds();
    });
    this.mapsApiLoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
    if (!this.candidature) {
      this.back();
    }
    this.accountService.identity().subscribe(account => {
      this.account = account;
    });
    this.createMarkers();
  }

  getLocations(): string {
    if (this.candidature?.locations) {
      let result = [];

      for (let i = 0; i < this.candidature.locations.length; i++) {
        if (this.candidature.locations[i].county) {
          result.push(this.candidature.locations[i].county);
        }
      }
      result = Array.from(new Set(result));
      return result.join(', ');
    }
    return '';
  }

  mapReady($event: GoogleMap): void {
    this.map = $event;
  }

  createMarkers(): void {
    this.markers = [];
    if (this.candidature && this.candidature.locations) {
      const locations = this.candidature.locations;
      if (locations && locations.length > 0) {
        for (let j = 0; j < locations.length; j++) {
          if (locations[j].latitude && locations[j].longitude) {
            this.insertIntoMarkers(j, Number(locations[j].latitude), Number(locations[j].longitude));
          }
        }
      }
    }
  }

  insertIntoMarkers(i: number, latitude: number, longitude: number): void {
    if (this.candidature) {
      this.markers.push({ lat: latitude, lng: longitude, title: this.candidature.id + '' + i });
      this.mapLat = latitude;
      this.mapLng = longitude;
    }
  }

  signIn(): void {
    if (!this.account || !this.account.id) {
      this.loginService.login();
      return;
    }
    this.sharedDataService.geracaozCandidature = this.candidature;
    void this.router.navigate(['geracaoz/inscricao']);
  }

  openTaskModal(record: ITask): void {
    const modalRef = this.modalService.open(GeracaozCandidatureFrontendTaskComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'frontend-modal',
    });
    modalRef.componentInstance.taskId = record.id;
  }

  back(): void {
    void this.router.navigate(['geracaoz/acoes']);
  }

  getTasks(): ITask[] {
    return this.candidature?.tasks || [];
  }
}
